var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmployeeInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.947 28.9668C27.3013 27.1594 25.8784 25.5623 23.8991 24.4232C21.9198 23.2842 19.4947 22.6667 16.9998 22.6667C14.505 22.6667 12.0798 23.2842 10.1005 24.4232C8.12124 25.5623 6.6984 27.1594 6.05268 28.9668",
    stroke: "white",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0002,
    cy: 11.3334,
    r: 5.66667,
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeInactive);
export default __webpack_public_path__ + "static/media/Employee-Inactive.b1c4e9f40f2e5fc98b548dd879d9b66b.svg";
export { ForwardRef as ReactComponent };